const certificates = [
  {
    name: 'Technology Workshop -  Realtime Communication',
    issuing_organization: 'Tokopedia',
    issue_date: 'Dec 2023',
    url: 'https://drive.google.com/file/d/1Mt0UNHTtoKp73IS7rylHJBrBf02Jc8jH/view?usp=sharing'
  },
  {
    name: 'Belajar Membangun Arsitektur Microservices',
    issuing_organization: 'Dicoding Indonesia',
    issue_date: 'Oct 2023',
    url: 'https://www.dicoding.com/certificates/07Z68Q0OYXQR'
  },
  {
    name: 'Create a CRM Mobile Application with React Native',
    issuing_organization: 'LinkedIn',
    issue_date: 'Oct 2023',
    url: 'https://www.linkedin.com/learning/certificates/093fc8209f85476e6c5fb5d380b944046d264f4bb50f37dd7c2679cd8e0c8751'
  },
  {
    name: 'From React to React Native',
    issuing_organization: 'LinkedIn',
    issue_date: 'Oct 2023',
    url: 'https://www.linkedin.com/learning/certificates/cb6ab92d970c17ea7680e9eee8dfd707d18d927c103eafdebd74669a2211d361'
  },
  {
    name: 'Docker for Developers',
    issuing_organization: 'LinkedIn',
    issue_date: 'Sep 2023',
    url: 'https://www.linkedin.com/learning/certificates/5572005b598537b1b5aeefc1124d4713aa0fa07a7919103c076c216dd49d339a'
  },
  {
    name: 'Learning GraphQL',
    issuing_organization: 'LinkedIn',
    issue_date: 'Sep 2023',
    url: 'https://www.linkedin.com/learning/certificates/be5e092504d33a7ed0b24bd516736bde0ee6aa23087c0585feee94204db405e5'
  },
  {
    name: 'Implementasi CI/CD',
    issuing_organization: 'Dicoding Indonesia',
    issue_date: 'Jul 2023',
    url: 'https://www.dicoding.com/certificates/QLZ9QND4MZ5D'
  },
  {
    name: 'Menjadi Linux System Administrator',
    issuing_organization: 'Dicoding Indonesia',
    issue_date: 'Jul 2023',
    url: 'https://www.dicoding.com/certificates/1RXY6WDM1ZVM'
  },
  {
    name: 'Python - Data Science',
    issuing_organization: 'SanberCode',
    issue_date: 'Nov 2022',
    url: 'https://sanbercode.com/sertifikat/generate/71e38daf-de56-46db-ad68-dfdacbeca8cc'
  },
  {
    name: 'Belajar Dasar-Dasar DevOps',
    issuing_organization: 'Dicoding Indonesia',
    issue_date: 'Oct 2022',
    url: 'https://www.dicoding.com/certificates/0LZ0GDNNKX65'
  },
  {
    name: 'Belajar Jaringan Komputer untuk Pemula',
    issuing_organization: 'Dicoding Indonesia',
    issue_date: 'Oct 2022',
    url: 'https://www.dicoding.com/certificates/MEPJKL996X3V'
  },
  {
    name: 'Next JS',
    issuing_organization: 'SanberCode',
    issue_date: 'Oct 2022',
    url: 'https://sanbercode.com/sertifikat/generate/d0c37d31-2f3b-425c-9177-6a0a3ae38075'
  },
  {
    name: 'Server-side Development with NodeJS, Express and MongoDB',
    issuing_organization: 'Coursera',
    issue_date: 'Sep 2022',
    url: 'https://coursera.org/share/094c49943dfb52432348c789107db86f'
  },
  {
    name: 'Belajar Back-End Pemula dengan JavaScript',
    issuing_organization: 'Dicoding Indonesia',
    issue_date: 'Sep 2022',
    url: 'https://www.dicoding.com/certificates/81P2GYG8NPOY'
  },
  {
    name: 'Frontend Engineering Bootcamp',
    issuing_organization: 'Ruangguru CAMP',
    issue_date: 'Jul 2022',
    url: 'https://drive.google.com/file/d/1CA_oELZJjyXavncF8BZRaXDNJNOUa0QM/view?usp=sharing'
  },
  {
    name: 'Belajar RESTful API untuk Pemula',
    issuing_organization: 'Programmer Zaman Now',
    issue_date: 'May 2022',
    url: 'https://drive.google.com/file/d/1A-fgcefB2gVee0QTYs1T5nl4w05GGMnm/view?usp=sharing'
  },
  {
    name: 'Belajar OpenAPI untuk Pemula',
    issuing_organization: 'Programmer Zaman Now',
    issue_date: 'Apr 2022',
    url: 'https://drive.google.com/file/d/1peeCpFgvIsTUZC4NbfxaQL60lX9gs00E/view?usp=sharing'
  },
  {
    name: 'Agile Development using Scrum Framework (Basic) ',
    issuing_organization: 'SanberCode',
    issue_date: 'Jan 2022',
    url: 'https://sanbercode.com/sertifikat/generate/e1d61e66-1e5d-469e-befa-49776888c63d'
  },
  {
    name: 'React Js Web Frontend',
    issuing_organization: 'SanberCode',
    issue_date: 'Dec 2021',
    url: 'https://sanbercode.com/sertifikat/generate/59beb3f9-fa43-4fea-bb48-2a2ebd22e9ae'
  },
  {
    name: 'Building Modern Python Applications on AWS',
    issuing_organization: 'Coursera',
    issue_date: 'Jun 2021',
    url: 'https://www.coursera.org/account/accomplishments/certificate/69CXV3X8W2NX'
  },
  {
    name: 'AWS Cloud Technical Essentials',
    issuing_organization: 'Coursera',
    issue_date: 'Apr 2021',
    url: 'https://www.coursera.org/account/accomplishments/certificate/CEZPWWTUZA7W'
  },
  {
    name: 'Architecting on AWS (Membangun Arsitektur Cloud di AWS)',
    issuing_organization: 'Dicoding Indonesia',
    issue_date: 'Dec 2021',
    url: 'https://www.dicoding.com/certificates/07Z65D03JXQR'
  },
  {
    name: 'Cloud Practitioner Essentials',
    issuing_organization: 'Dicoding Indonesia',
    issue_date: 'Aug 2021',
    url: 'https://www.dicoding.com/certificates/0LZ036RL0Z65'
  }
]

export default certificates
